import { createRouter, createWebHistory } from "vue-router";
import Browser from "../browser/browser";

const Login = () => import("../../components/auth/loginPage.vue");
const Register = () => import("../../components/auth/registerPage.vue");
const Main = () => import("../../components/home/mainPage.vue");
const CallStudent = () => import("../../components/callStudent/callStudentPage.vue");
const ClassPage = () => import("../../components/classpage/classPage.vue");
const Student = () => import("../../components/student/studentPage.vue");
const Group = () => import("../../components/group/groupPage.vue");


const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/home",
    name: "Main",
    component: Main,
    children: [
      {
        path: "call",
        name: "CallStudent",
        component: CallStudent,
      },
      {
        path: "calss",
        name: "ClassPage",
        component: ClassPage,
      },
      {
        path: "student",
        name: "Student",
        component: Student,
      },
      {
        path: "group",
        name: "Group",
        component: Group,
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  //console.log("to---" + to);
  //console.log("from---" + from);
  //console.log(navigator.userAgent);
  //console.log("进到 router beforeeach 里面了");
  if (Browser.isAndroid() || Browser.isIOS()) {
    next();    
  } else {
    const nextRoute = [
      "Login",
      "Register",
    ];
    let isLogin = localStorage.getItem("calltoken");
    const tt = localStorage.getItem("saveTokenTime");
    // 超过1小时踢出去
    if(Date.now() - parseFloat(tt) > 3600*1000) {
      isLogin = false;
    }
    // //console.log(!isLogin);
    // //console.log("TTT-" + to.name);
    // //console.log(nextRoute.indexOf(to.name) >= 0);
    if (isLogin && nextRoute.indexOf(to.name) < 0) {
      next();
    } else {
      if (nextRoute.indexOf(to.name) >= 0) {
        next();
      } else {
        next({
          path: "/",
          // 将跳转的路由path作为参数，登录成功后跳转到该路由
          query: { redirect: to.fullPath },
        });
      }
    }
      // if (!isLogin && nextRoute.indexOf(to.name) >= 0) {
      //   next({
      //     path: "/login",
      //     // 将跳转的路由path作为参数，登录成功后跳转到该路由
      //     query: { redirect: to.fullPath },
      //   });
      // } else {
      //   next();
      // }
    // 已登录状态；当路由到login时，跳转至home
    if (to.name === "Login" || to.name == undefined) {
      if (isLogin) {
        router.push({ path: "/home" });
      }
    }
  }
});
export default router;